import React from 'react';
import 'Styles/Modal.scss';


function Modal(props) {
    return (
        <div className="modal__outer-wrapper" onClick={()=> props.viewModal(false)}>
            <div className="modal__inner-wrapper" onClick={(e)=> e.stopPropagation()}>
                {props.children}
            </div>
        </div>
    )
}

export default Modal;
